module.exports = __webpack_public_path__ + "img/std_thum.e976b242.png";